/*
 *
 * CheckUserEmail reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_CHECKUSEREMAIL,
  CHANGE_CHECKUSEREMAIL,
  CHANGE_CHECKUSEREMAIL_SUCCESS,
  CHANGE_CHECKUSEREMAIL_ERROR,
} from './constants';

export const initialState = {
  loadingCheckEmail: true,
  error: false,
  deleteSuccessful: false,
  itemsList: false,
  checkUserEmailData: false,
};

/* eslint-disable default-case, no-param-reassign */
const checkUserEmailReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_CHECKUSEREMAIL:
        return initialState;

      // CHANGE/UPDATE
      case CHANGE_CHECKUSEREMAIL:
        draft.checkUserEmailData = {
          ...state.checkUserEmailData,
          ...action.checkUserEmailData,
        };
        draft.loadingCheckEmail = true;
        draft.error = false;
        break;

      case CHANGE_CHECKUSEREMAIL_SUCCESS:
        draft.checkUserEmailData = action.checkUserEmailData;
        draft.loadingCheckEmail = false;
        break;

      case CHANGE_CHECKUSEREMAIL_ERROR:
        draft.error = action.error;
        draft.loadingCheckEmail = false;
        break;
    }
  });

export default checkUserEmailReducer;
